import React, {useState} from 'react';
import Navbar from "../../components/Navbar";
import Sidebar, {ALLOWED_WHEN_NOT_RECAPTURED} from "../../components/Sidebar";
import { Navigate, Outlet, useLocation} from "react-router-dom";
import {logoutUser} from "../../redux/auth/authSlice";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {RouteNames} from "../../constants";


const DashboardLayout = ()=>{
    const dispatch = useAppDispatch();
    const location = useLocation();
    const [showSideBar, setShowSideBar] = useState(false);
    const toggleShowSidebar = () => setShowSideBar(!showSideBar);
    const { user }  = useAppSelector(state=>state.auth)

    const closeSideBar = ()=>setShowSideBar(false);
    const logout = ()=>{
        closeSideBar();
        dispatch(logoutUser());
    }

    const isRecaptured = !!user?.isRecaptured;
    const isRegistrationIncomplete = !!user?.isRegistrationIncomplete;
    const path = location.pathname;
    const isRecaptureRoute =
        path === RouteNames.RECAPTURE || path === RouteNames.RECAPTURE_STATUS;

    if (user && isRegistrationIncomplete && path !== RouteNames.HOME && path !== RouteNames.DASHBOARD && path !== RouteNames.REGISTER_COMPLETE) {
        return <Navigate to={RouteNames.REGISTER_COMPLETE} replace />;
    }
    if (user && !isRecaptured && !isRegistrationIncomplete && !ALLOWED_WHEN_NOT_RECAPTURED.has(path)) {
        return <Navigate to={RouteNames.HOME} replace />;
    }
    if (user && isRecaptured && !isRegistrationIncomplete && isRecaptureRoute) {
        return <Navigate to={RouteNames.HOME} replace />;
    }

    return (
        <React.Fragment>
            <div className="dashboard-layout">
                <Sidebar
                    showSideBar={showSideBar}
                    user={user}
                    closeSideBar={closeSideBar}
                    logout={logout}
                />
                <div className="dashboard-main">
                    <Navbar
                        toggleShowSidebar={toggleShowSidebar}
                        user={user}
                        logout={logout}
                    />
                    <div className="dashboard-page-item">
                        <Outlet />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
export default DashboardLayout;
